export class StringResult {
  object = 'stringResult';
  result: string;
}
